import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";
import SummarizerContent from "./SummarizerContent";
import WhyWeNeedTextSummarizer from "./WhyWeNeedTextSummarizer";

function SummarizerMain() {
  return (
    <div>
      {/*Firebase analytics */}
      {logEvent(analytics, "AI Text Summarizer Screen")}

      {/*Add title and metadata */}
      <title>Free Text Summarizer - AI Summarization Tool</title>
      <meta name="robots" content="index, follow"></meta>
      <link rel="canonical" href="https://humanizetexts.com/text-summarizer" />
      <meta
        name="description"
        content="Boost your productivity with our powerful Text Summarizer – an AI-powered tool that quickly generates concise and accurate summaries from long texts, news, articles, documents, or essays. Whether you're a student, researcher, writer, or professional, our free text summarizer helps you extract the most important information instantly. Just copy, paste, and summarize in seconds!"
      ></meta>
      <meta
        name="keywords"
        content="text summarizer,text summarization,summarization tools,summarize news,summarize articles,summarize story,minify news,one click summarizer,free text summarizer,text summarizer online,artifical intelligence,summarizer ai,"
      ></meta>
      <meta
        property="og:title"
        content="AI Text Summarizer - Summarization Tool - AI"
      />
      <meta
        name="twitter:title"
        content="AI Text Summarizer - Summarization Tool - AI"
      ></meta>

      {/* Main Content */}
      <div className="p-3">
        {/* NavBar component */}
        <NavBar />
        {/* Content */}
        <SummarizerContent />
        {/* Why we need text summarizer */}
        <WhyWeNeedTextSummarizer/>
        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}

export default SummarizerMain;
